import CartPaymentContainer from './CartPaymentContainer';

export default CartPaymentContainer;
